import axios from "axios";
import rand from "./random";

export default class Requests {
    static async getRecords(lvlid) {
        try {
            const r = await axios.get('./demonlist/records.txt?' + rand.getRandomInt(111, 999));
            const lines = r.data.split('\n');
            let result = '';

            for(let i = 0; i < lines.length; i++) {
                if(!lines[i]) continue;
                else if(!lines[i].includes(';' + lvlid + ';')) continue;

                result += lines[i] + '\n';
            }

            return { data: result };
        } catch(e) {
            throw new Error(e.message);
        }
    }

    static async getLeaders(list) {
        try {
            const recordsResponse = await axios.get('./demonlist/records.txt?' + rand.getRandomInt(111, 999));
            const recordsLines = recordsResponse.data.split('\n');
            const listResponse = await axios.get(`./demonlist/${list.replace(/_/g, '')}.txt`); 
            const demonsLines = listResponse.data.split('\n');
      
            let r = '';
        
            for (let i = 0; i < recordsLines.length; i++) {
                const recordLine = recordsLines[i];
                if (!recordLine) continue;
        
                if (recordLine.includes(list)) {
                    let points = 0;
            
                    for (let j = 0; j < demonsLines.length; j++) {
                        const demonLine = demonsLines[j];
                        if (!demonLine) continue;
            
                        const params = demonLine.split(';');
                        if (recordLine.includes(`;${params[2]};`)) {
                        points = params[4];
                        break;
                        }
                    }
            
                    if (points !== 0) {
                        r += recordLine + ';' + points + "\n";
                    }
                }
            }
      
            return { data: r };
        } catch (error) {
            console.error("Error fetching data:", error);
            return null;
        }
    }

    static async getUserRecords(userName, list) {
        try {
            const recordsResponse = await axios.get('./demonlist/records.txt?' + rand.getRandomInt(111, 999));
            const recordsData = recordsResponse.data;
            const recordsLines = recordsData.split('\n');
        
            const listFileName = `./demonlist/${list.replace('_', '')}.txt`;
            const listResponse = await axios.get(listFileName);
            const listFileData = listResponse.data;
            const levels = listFileData.split('\n');
        
            let result = '';
        
            for (let i = 0; i < recordsLines.length; i++) {
                const recordLine = recordsLines[i];
                if (!recordLine) continue;
            
                const params = recordLine.split(';');
                if (params[0] !== userName) continue;
                if (params[2] !== list) continue;
            
                let levelName = '';
                let levelPoints = 0;
            
                for (let j = 0; j < levels.length; j++) {
                    const levelLine = levels[j];
                    if (!levelLine) continue;
            
                    const levelParams = levelLine.split(';');
                    if (levelParams[2] !== params[1]) continue;
            
                    levelName = levelParams[0];
                    levelPoints = parseInt(levelParams[4], 10);
                    break;
                }
            
            
                if (levelName && levelPoints > 0) {
                    result += `${recordLine};${levelName};${levelPoints}\n`;
                }
            }
        
            return { data: result };
        } catch (error) {
            console.error("Error fetching data:", error);
            return null;
        }
    }
}